import { useEffect, useRef, useState } from "react";
import { t } from "@/game/i18n";

const SLIDES = [
  { src: "/intro/intro_1.jpg", key: "intro1" as const, anim: "kb-right", pos: "72% 45%" },
  { src: "/intro/intro_2.jpg", key: "intro2" as const, anim: "kb-down", pos: "50% 50%" },
  { src: "/intro/intro_3.jpg", key: "intro3" as const, anim: "kb-up", pos: "50% 60%" },
];
const SLIDE_MS = 3000;

export const IntroScene = ({ onDone }: { onDone: () => void }) => {
  const [idx, setIdx] = useState(0);
  const mounted = useRef(performance.now());
  const onTap = () => { if (performance.now() - mounted.current < 700) return; setIdx((i) => (i + 1 >= SLIDES.length ? (onDone(), i) : i + 1)); };
  useEffect(() => {
    SLIDES.forEach((s) => { const im = new Image(); im.src = s.src; });
    const iv = setInterval(() => setIdx((i) => i + 1), SLIDE_MS);
    const end = setTimeout(onDone, SLIDE_MS * SLIDES.length + 600);
    return () => { clearInterval(iv); clearTimeout(end); };
  }, [onDone]);
  return (
    <div data-testid="intro-scene" className="intro-scene" onClick={onTap}>
      {SLIDES.map((s, i) => (
        <div key={s.key} className={`intro-slide ${i === idx ? "is-active" : i < idx ? "is-past" : ""}`} data-testid={`intro-slide-${i + 1}`}>
          <img src={s.src} alt="" className={`intro-img ${i === idx ? s.anim : ""}`} style={{ objectPosition: s.pos }} />
          <div className="intro-vignette" />
          {i === idx && <p className="intro-caption" data-testid="intro-caption">{t(s.key)}</p>}
        </div>
      ))}
      <div className="intro-dots" aria-hidden="true">{SLIDES.map((_, i) => <span key={i} className={i === idx ? "on" : ""} />)}</div>
      <button type="button" data-testid="intro-skip-button" className="intro-skip" onClick={(e) => { e.stopPropagation(); onDone(); }}>{t("skip")} ›</button>
    </div>
  );
};
